import { Col, Form, Row } from 'antd';
import { SelectForm } from 'components';

const Establish = () => {
  return (
    <div className="pt-3 pb-10">
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12} className="h-[80px]">
          <Form.Item
            rules={[{ required: true }]}
            label="Loại phê duyệt"
            name="type"
          >
            <SelectForm
              className="text-red"
              placeholder="Chọn loại phê duyệt"
              options={[
                {
                  value: 'sequentially',
                  label: 'Tuần tự',
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={12} className="h-[80px]">
          <Form.Item
            rules={[{ required: true }]}
            label="Cấp phê duyệt"
            name="level"
          >
            <SelectForm
              className="text-red"
              placeholder="Chọn cấp phê duyệt"
              options={[
                {
                  value: '1',
                  label: '1',
                },
                {
                  value: '2',
                  label: '2',
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default Establish;
